<template>
<div class="form-group row">
    <div class="col-md-6">
        <label>About Bussiness</label>
        <fieldset class="form-group mb-3">
            <textarea type="text" class="form-control border-dark" cols="12" rows="12" v-model="general.about_us"> </textarea>
        </fieldset>
    </div>
    <div class="col-md-6">
        <label>Address</label>
        <fieldset class="form-group mb-3">
            <textarea type="text" class="form-control border-dark" cols="12" rows="12" v-model="general.address"> </textarea>
        </fieldset>    
    </div>

	<div class="col-md-6">
        <label>Buiness Name</label>
        <fieldset class="form-group mb-3">
            <input type="text" class="form-control border-dark" placeholder="" v-model="general.business_name" ref="smtp_port">
        </fieldset>
    </div>

    <div class="col-md-6">
        <label>Phone Number</label>
        <fieldset class="form-group mb-3">
            <input type="text" class="form-control border-dark" placeholder="" v-model="general.phone_number" ref="smtp_port">
        </fieldset>
    </div>

	<div class="col-md-6">
        <label>Business Email</label>
        <fieldset class="form-group mb-3">
            <input type="email" class="form-control border-dark" placeholder="" v-model="general.email" ref="smtp_encription">
        </fieldset>
    </div>

    <div class="col-md-6">
        <label>New Badge Visibilty Time On Product Carts</label>
        <fieldset class="form-group mb-3">
            <input type="number" class="form-control border-dark" placeholder="" v-model="general.new_bage_on_product_card_visibility" ref="new_bage_on_product_card_visibility">
        </fieldset>
    </div>

    <div class="col-md-6">
        <label>Minimum Order Total</label>
        <fieldset class="form-group mb-3">
            <input type="number" class="form-control border-dark" placeholder="" v-model="general.minimum_order_total" ref="minimum_order_total">
        </fieldset>
    </div>

    <div class="col-md-6">
        <label>Minimum Order Price for Free Shipping</label>
        <fieldset class="form-group mb-3">
            <input type="number" class="form-control border-dark" placeholder="" v-model="general.free_shipping_order_price" ref="free_shipping_order_price">
        </fieldset>
    </div>

    <div class="col-md-6">
        <label>Registration Number (Рег. номер)</label>
        <fieldset class="form-group mb-3">
            <input type="text" class="form-control border-dark" placeholder="" v-model="general.reg_no" ref="reg_no">
        </fieldset>
    </div>

    <div class="col-md-6">
        <label>SWIFT Code</label>
        <fieldset class="form-group mb-3">
            <input type="text" class="form-control border-dark" placeholder="" v-model="general.swift" ref="swift">
        </fieldset>
    </div>

    <div class="col-md-6">
        <label>Bank Name</label>
        <fieldset class="form-group mb-3">
            <input type="text" class="form-control border-dark" placeholder="" v-model="general.bank" ref="bank">
        </fieldset>
    </div>

    <div class="col-md-6">
        <label>IBAN</label>
        <fieldset class="form-group mb-3">
            <input type="text" class="form-control border-dark" placeholder="" v-model="general.account" ref="account">
        </fieldset>
    </div>

    <div class="col-md-6">
        <label>Loading Address</label>
        <fieldset class="form-group mb-3">
            <input type="text" class="form-control border-dark" placeholder="" v-model="general.loading_address" ref="loading_address">
        </fieldset>
    </div>

    <div class="col-md-6">
        <label>VAT Number (НДС)</label>
        <fieldset class="form-group mb-3">
            <input type="text" class="form-control border-dark" placeholder="" v-model="general.vat_no" ref="vat_no">
        </fieldset>
    </div>

    <div class="col-md-6">
        <label>PVD Registration Number</label>
        <fieldset class="form-group mb-3">
            <input type="text" class="form-control border-dark" placeholder="" v-model="general.pvd_reg_no" ref="pvd_reg_no">
        </fieldset>
    </div>

    <div class="col-md-12">
        <hr>
        <h5 class="mb-3">Реквизиты РФ</h5>
    </div>

    <div class="col-md-6">
        <label>ИНН</label>
        <fieldset class="form-group mb-3">
            <input type="text" class="form-control border-dark" placeholder="" v-model="general.inn" ref="inn">
        </fieldset>
    </div>

    <div class="col-md-6">
        <label>КПП</label>
        <fieldset class="form-group mb-3">
            <input type="text" class="form-control border-dark" placeholder="" v-model="general.kpp" ref="kpp">
        </fieldset>
    </div>

    <div class="col-md-6">
        <label>ОГРН</label>
        <fieldset class="form-group mb-3">
            <input type="text" class="form-control border-dark" placeholder="" v-model="general.ogrn" ref="ogrn">
        </fieldset>
    </div>

    <div class="col-md-6">
        <label>БИК</label>
        <fieldset class="form-group mb-3">
            <input type="text" class="form-control border-dark" placeholder="" v-model="general.bik" ref="bik">
        </fieldset>
    </div>

    <div class="col-md-6">
        <label>Расчётный счёт</label>
        <fieldset class="form-group mb-3">
            <input type="text" class="form-control border-dark" placeholder="" v-model="general.checking_account" ref="checking_account">
        </fieldset>
    </div>

    <div class="col-md-6">
        <label>Корреспондентский счёт</label>
        <fieldset class="form-group mb-3">
            <input type="text" class="form-control border-dark" placeholder="" v-model="general.corr_account" ref="corr_account">
        </fieldset>
    </div>

    <div class="col-md-12">
        <hr>
        <h5 class="mb-3">Ценообразование</h5>
        <p class="text-muted" style="font-size: 13px;">
            Цены считаются от цены закупки в долларах:
            закупка &times; курс &times; коэффициент.
            Товары с отметкой &laquo;цена задана вручную&raquo; пересчёт не трогает.
        </p>
    </div>

    <div class="col-md-6">
        <label>Курс USD &rarr; RUB</label>
        <fieldset class="form-group mb-3">
            <input type="number" step="0.0001" min="0" class="form-control border-dark" v-model="general.usd_rub_rate" ref="usd_rub_rate">
            <small class="text-muted">По нему цена закупки переводится в рубли.</small>
        </fieldset>
    </div>

    <div class="col-md-6">
        <label>Коэффициент розничной цены (B2C)</label>
        <fieldset class="form-group mb-3">
            <input type="number" step="0.01" min="0" class="form-control border-dark" v-model="general.retail_price_coefficient" ref="retail_price_coefficient">
            <small class="text-muted">0 &mdash; не задан, цены B2C не рассчитываются. Цена получается с НДС.</small>
        </fieldset>
    </div>

    <div class="col-md-12">
        <p class="text-muted" style="font-size: 13px;">
            Коэффициенты B2B задаются у каждого бренда отдельно &mdash; обычный и специальный,
            в разделе <router-link to="/admin/brand">Бренды</router-link>. Цена B2B выводится без НДС.
        </p>
    </div>

    <div class="col-md-12">
        <br />
        <button @click="updateSetting()" type="submit" class="btn btn-primary">Submit</button>
    </div>
</div>
</template>

<script>
import ErrorHandling from './../../../ErrorHandling'
export default {
    data() {
        return {
            general: {
                about_us:"",
                address:"",
                business_name:"",
                phone_number:"",
                email:"",
                new_bage_on_product_card_visibility:"",
                minimum_order_total:"",
                free_shipping_order_price:"",
                reg_no:"",
                swift:"",
                bank:"",
                account:"",
                loading_address:"",
                vat_no:"",
                pvd_reg_no:"",
                usd_rub_rate:"",
                retail_price_coefficient:""
            },
            errors: new ErrorHandling(),
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        };
    },

    methods: {
        fetchSetting() {
            this.$emit('updateLoadingState', true);
            var token = localStorage.getItem('token');
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };
            var responseData = {};

            axios.get('/api/admin/setting?type=business_general', config)
                .then(res => {
                    for (var i = 0; i < res.data.data.length; i++) {
                        Object.assign(responseData, {
                            [res.data.data[i].setting_key]: res.data.data[i].setting_value
                        });
                    }
                    console.log('response datass', responseData);
                    this.general = responseData;
                })
                .finally(() => (this.$emit('updateLoadingState', false)));
        },

        updateSetting() {
            this.$emit('updateLoadingState', true);
            var general = Object.entries(this.general);
            var key = [];
            var value = [];

            for (var i = 0; i < general.length; i++) {
                key.push(general[i][0]);
                value.push(general[i][1])
            }
            

            // console.log(key, value);

            var token = localStorage.getItem('token');
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };

            axios.post('/api/admin/setting/business_general', {
                    _method: 'PUT',
                    key,
                    value
                }, config)
                .then(res => {
                    if (res.data.status == "Success") {
						this.$toaster.success('Settings has been updated successfully')
                    }
                    else if(res.data.status == 'Error'){
                        this.$toaster.error(res.data.message)
                    }
                    
                })
                .catch(err => {
                    const data = err.response && err.response.data;

                    if (data && data.status == 'Error') {
                        this.$toaster.error(data.message)
                    } else if (data && data.errors) {
                        // Validation errors have a different shape and used to be
                        // swallowed silently, which looked like "nothing was saved".
                        this.$toaster.error(Object.values(data.errors).flat().join(' '))
                    } else if (data && data.message) {
                        this.$toaster.error(data.message)
                    } else {
                        this.$toaster.error('Не удалось сохранить настройки')
                    }
                })
                .finally(() => (this.$emit('updateLoadingState', false)));

        }
    },
    mounted() {
        this.fetchSetting();
    }
};
</script>
